import { IBankAccount } from '@commenda/api/bankAccount';
import { useState } from 'react';

import { BankAccountCard } from '../../../Corporation/BankAccounts/BankAccountCard';
import { BankAccountViewDrawer } from '../../../Corporation/BankAccounts/BankAccountViewDrawer';

interface IndirectTaxFilingDetailRemittanceAccountProps {
  account: IBankAccount | null;
}

const IndirectTaxFilingDetailRemittanceAccount = ({
  account,
}: IndirectTaxFilingDetailRemittanceAccountProps) => {
  const [viewAccount, setViewAccount] = useState<IBankAccount | null>(null);

  return (
    <div className="flex flex-col gap-md">
      <span className="txt-small-regular text-text-secondary">
        Remittance bank account
      </span>
      {account ? (
        <BankAccountCard account={account} onClick={setViewAccount} />
      ) : (
        <span className="txt-small-regular text-text-tertiary">
          No account added
        </span>
      )}

      <BankAccountViewDrawer
        account={viewAccount}
        isOpen={!!viewAccount}
        onClose={() => setViewAccount(null)}
      />
    </div>
  );
};

export { IndirectTaxFilingDetailRemittanceAccount };
